"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoadingIndicatorStyles = exports.loadingIndicatorVars = exports.loadingIndicatorCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var loadingIndicatorCommon = exports.loadingIndicatorCommon = _commonProps.defaultCommonProps;
var loadingIndicatorVars = exports.loadingIndicatorVars = (0, _initVars.default)({
  applied: loadingIndicatorCommon,
  variables: [{
    key: "loadingIndicatorColor"
  }, {
    key: "loadingIndicatorSize",
    defaultUnit: "px"
  }, {
    key: "loadingIndicatorThickness",
    defaultUnit: "px"
  }]
});
var styles = function styles(theme) {
  return {
    variables: loadingIndicatorVars.styles,
    root: {
      display: "flex",
      flexFlow: "column",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
      textAlign: "center",
      width: "100%",
      height: "auto",
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.fontSize,
      color: theme.colors.baseContrast070
    },
    spinner: {
      boxSizing: "content-box",
      display: "inline-block",
      willChange: "transform",
      animation: "$LoadingIndicatorRotate 1s linear infinite",
      borderStyle: "solid",
      borderRadius: "50%",
      borderRightColor: "transparent",
      borderWidth: loadingIndicatorVars.get("loadingIndicatorThickness"),
      width: loadingIndicatorVars.get("loadingIndicatorSize"),
      height: loadingIndicatorVars.get("loadingIndicatorSize"),
      borderTopColor: loadingIndicatorVars.get("loadingIndicatorColor", theme.colors.primary),
      borderBottomColor: loadingIndicatorVars.get("loadingIndicatorColor", theme.colors.primary),
      borderLeftColor: loadingIndicatorVars.get("loadingIndicatorColor", theme.colors.primary)
    },
    "@keyframes LoadingIndicatorRotate": {
      "100%": {
        transform: "rotate(360deg)"
      }
    }
  };
};
var useLoadingIndicatorStyles = exports.useLoadingIndicatorStyles = (0, _createUseStyles.default)(styles, {
  name: "LoadingIndicator"
});